import { HistoryStore } from '@iotv/datamodel';
import { SortOrder } from '@iotv/iotv-v3-types';
import { metricItemsToVOBs } from './helperFns';
const debug = process.env.REACT_APP_DEBUG && false;
export const getExportVOBs = ({ objectHistory, pseudoTypeId, observationMetricItems, combined, observationHistoryStore, observationHistory, actualReadingPrefix, matchedActualsCount, setMatchedActualsCount, }) => {
    const matchObserveredKeys = true;
    let vobs = [];
    let keys = [];
    if (!combined) {
        vobs = observationMetricItems;
        keys = observationHistoryStore?.keys() ?? [];
    }
    else if (objectHistory?.recentStateHistory && observationHistoryStore) {
        const historyStoreClone = observationHistoryStore.clone();
        const sortOrder = SortOrder.DESCENDING;
        historyStoreClone.sort(sortOrder);
        const historyStoreCloneKeys = historyStoreClone.keys();
        debug && console.log(`historyStoreCloneKeys`, historyStoreCloneKeys);
        debug && console.log('clone is in order', historyStoreClone.validate(sortOrder));
        const recentStateHistory = new HistoryStore({ ...objectHistory.recentStateHistory });
        const [firstTs, lastTs] = [historyStoreClone.getFirstTimestamp(), historyStoreClone.getLastTimestamp()].sort();
        debug && console.log('first last ', { firstTs, lastTs });
        const max = Math.max(recentStateHistory.getIndexLastLessThanTimestamp(firstTs ?? recentStateHistory.getFirstTimestamp() ?? 0), 0);
        const min = Math.min(recentStateHistory.getIndexLastLessThanTimestamp(lastTs ?? recentStateHistory.getLastTimestamp() ?? 0) + 1, recentStateHistory.getLength() - 1);
        const [start, end] = [min, max].sort();
        debug && console.log('trimming to ', { start, end });
        const trimmedRecentStateHistory = new HistoryStore(objectHistory.recentStateHistory).slice([start, end]);
        trimmedRecentStateHistory.keys().forEach((k) => {
            // need to remove objects
            const stateArray = trimmedRecentStateHistory[k];
            const containsObject = stateArray.some((item) => typeof item === 'object' && item !== null);
            const keyMatchesObserved = historyStoreCloneKeys.includes(k) || !matchObserveredKeys;
            debug && console.log(`export keys predicates for ${k}`, { containsObject, keyMatchesObserved, matchObserveredKeys });
            if (!containsObject && keyMatchesObserved)
                trimmedRecentStateHistory[`${actualReadingPrefix}${k}`] = trimmedRecentStateHistory[k];
            delete trimmedRecentStateHistory[k];
        });
        debug && console.log('trimmedRecentStateHistory', trimmedRecentStateHistory);
        const recentStateHistorySnapshots = trimmedRecentStateHistory.getStateSnapshotArray();
        if (matchedActualsCount !== recentStateHistorySnapshots.length)
            setMatchedActualsCount(recentStateHistorySnapshots.length);
        const observatinStateSnapshots = historyStoreClone.getStateSnapshotArray();
        const orderedSnapshots = [...observatinStateSnapshots, ...recentStateHistorySnapshots].sort((s1, s2) => s1.timestamp - s2.timestamp);
        keys = [...historyStoreCloneKeys, ...trimmedRecentStateHistory.keys()];
        vobs = metricItemsToVOBs({ psuedoParentVob: observationHistory, pseudoTypeId, stateSnapshots: orderedSnapshots });
        debug && console.log('vobs  count', vobs.length);
        debug && console.log('export keys', keys);
        debug && console.log('combined', combined);
    }
    return { keys, vobs };
};
